import axios from "axios";
export const http = axios.create({
  baseURL: "https://backend-owner.egmokka.com",
  headers: {
  	"Authorization": localStorage.getItem('Token'),
    "Content-Type": "multipart/form-data"
  }
});

export default axios.create({
  baseURL: "https://backend-owner.egmokka.com",
  headers: {
  	// "Authorization": localStorage.getItem('Token'),
    'Authorization': 'Bearer 1+1',
    "Content-Type": "multipart/form-data"
  }
});
